import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem, MenuItemExternal } from './model/navbar.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LinkConfig } from '@collab/comp-library';
import { ROUTE_ASSETS_ICON, SVG } from 'src/app/shared/constants/route-path';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() public items: string[] = [];
  @Input() public menuItemsExternal?: MenuItemExternal[];
  @Output() public toggleNav: EventEmitter<boolean> = new EventEmitter<boolean>();
  public iconClassName: 'icon-Chev-Left' | 'icon-Chev-Right' = 'icon-Chev-Left';

  public MenuItems: MenuItem[] = [];

  // public icons = { menu: ICONS.MENU };

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  public ngOnInit(): void {
    for (let i = 0; i < this.router.config.length; i++) {
      const menuItemObj: MenuItem = {
        path: this.router.config[i].path ?? '',
        title: this.router.config[i].data?.['title'] ?? '',
        label: this.router.config[i].data?.['navLabel'] ?? '',
        icon: this.router.config[i].data?.['navIcon'] ?? '',
        comingSoon: this.router.config[i].data?.['isComingSoon'] ?? '',
        isLinkDisabled: this.router.config[i].data?.['isComingSoon'] ?? '',
      };

      if (this.items.indexOf(menuItemObj.label) !== -1) {
        this.MenuItems.push(menuItemObj);
      }
    }
  }


  /**
   * for sidebar collapse and expand navbar
   * @return {*}  {boolean}
   * @memberof NavbarComponent
   */

  public toggleSideNav(): void {
    this.iconClassName = this.iconClassName === 'icon-Chev-Left' ? 'icon-Chev-Right' : 'icon-Chev-Left';
    this.toggleNav.emit();
  }

  /**
   *
   * this methos will return the url for icons
   * @param {string} icon
   * @return {*}  {string}
   * @memberof NavbarComponent
   */
  public getUrl(icon = ''): string {
    let url = '';
    if (icon) {
      url = ROUTE_ASSETS_ICON + icon;
      if (!icon.includes('.')) {
        url += SVG;
      }
    }
    // return icon ? ROUTE_ASSETS_ICON + (icon.includes('.') ? icon : (icon + SVG)) : '';
    return url;
  }

  public routeLinkConfig(label: string): LinkConfig {
    return {
      hrefVal: '',
      linkText: label
    };
  }

  public routeToPath(path: string): void {
    const routed = this.router.navigateByUrl(path);
  }
}
